<template>
    <div>
        <label class="custom-control custom-checkbox" v-bind:class="{ 'has-danger' : error !== null }">
            <span class="custom-control-indicator"></span>
            <input type="checkbox" class="custom-control-input" v-model="model">
            <span class="custom-control-description">{{ labelComputed }}</span>
        </label>
        <span class="help-block form-control-feedback" v-if="error != null" v-text="error"></span>
    </div>
</template>

<script>
    import ElementMixin from '~/mixins/element'

    export default {
        name: 'form-checkbox',

        mixins: [
            ElementMixin,
        ],

        props: {},

        data() {
            return {}
        },
    }
</script>

<style lang="scss" scoped>
</style>